import { useCurrentWorkspaceId } from '@/store/auth.store';
import { useWorkspaces } from './useWorkspaces';

/**
 * Returns true if the current user has ADMIN or OWNER role
 * in the currently selected workspace.
 */
export function useIsWorkspaceAdmin(): boolean {
  const currentWorkspaceId = useCurrentWorkspaceId();
  const { data: workspaces = [] } = useWorkspaces();

  if (!currentWorkspaceId) return false;

  const workspace = workspaces.find((w) => w.id === currentWorkspaceId);
  return workspace?.workspaceRole === 'ADMIN' || workspace?.workspaceRole === 'OWNER';
}
